import { createFileRoute } from '@tanstack/react-router'
import { UnitFormPage } from '../../../../../components/campaigns/UnitFormPage'

/** The agent's form for one unit of a campaign (spec 2026-10-20-12 §6). */
export const Route = createFileRoute('/$org/campaigns/$campaignUid/units/$unitUid')({
  component: UnitFormPage,
})
